import React, { Component } from 'react';
import { Modal } from 'antd';
import Statistics from '../../Statistics';

class ArticledetailsModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
      config: null,
      propsData:{}
    });
  };

  show = ({config,propsData}) => {
    this.setState({ visible: true,config,propsData})
  }

  render() {
    let {config,propsData={}} = this.state;
    if(!config) return null
    let {modalbodyStyle={},modalTitle='',modalFooter=null,modalWidth=300,modalBodyConfig={}} = config
    return (
        <Modal
            maskClosable={false}
            title={modalTitle}
            footer={modalFooter}
            width={modalWidth}
            visible={this.state.visible}
            onCancel={this.handleCancel}
            bodyStyle={modalbodyStyle}
            className="modalClass"

        >
          <Statistics  config={modalBodyConfig} match={config.match} defaultStateData={propsData}/>

          <style>{`
          .modalClass .ant-modal-body {
            padding: 0px !important;
          }
          
          .modalClass .renderTab {
            margin: 0px !important;
          }
        `}</style>
        </Modal>
    );
  }
}

export default ArticledetailsModal;

